import React from 'react';
import { useLocation } from 'react-router-dom';
import GenericFeatureForm from '../shared/generic-feature-form';
import { ReelTrendingAPI } from '../../services/feature-api';
import { getFeatureConfig } from '../../config/featureDisplayConfig';

const config = getFeatureConfig('reel-trending');

const ReelTrendingForm = (props) => {
  const location = useLocation();
  const editData = location.state?.editData || null;
  const isEdit = Boolean(editData);

  const handleSubmit = async (formData, accessToken) => {
    const result = isEdit
      ? await ReelTrendingAPI.update(accessToken, editData.id, formData)
      : await ReelTrendingAPI.create(accessToken, formData);
    if (!result.success) throw new Error(result.error || 'Lỗi khi lưu dữ liệu');
    return result;
  };

  return (
    <GenericFeatureForm
      title={isEdit ? 'Chỉnh sửa Reel xu hướng' : 'Tạo mới Reel xu hướng'}
      fields={config.formConfig.fields}
      onSubmit={handleSubmit}
      initialData={editData}
      backPath={config.path}
      accentColor={config.color}
      lockOnApproval={config.lockOnApproval}
      {...props}
    />
  );
};

export default ReelTrendingForm;
